import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {Addition} from "../../../price-plan/models/addition.model";
import {PriceType} from "../../../price-plan/types/price.type";
import {SplitService} from "../../../commons/services/split-service.service";
import {getFulfillmentLineItems} from "../../../fulfillment/utils/fulfillment-line-items.util";


export class OmsOrderPriceOverViewLineViewCtrl implements IController {
  form: any;
  order: any;
  priceOffer: any;
  isEditMode: boolean;
  showFreeLineAddition: any;
  onPriceOfferChange: Function;
  onOrderChange: Function;

  public additionOptions: Addition[];
  public currencySymbol: any;
  public lineBaseTotalPrice: any = {};
  public accessorialLines: any = {};
  public additionalLines: any = {};
  public finalAdditionLines: any = {};
  public finalAdditionLinesPrice: any = {};
  public finalAdditionLinesSummary: any = {};
  public freeLines: any = {};
  public accessorialLinesPrice: any = {};
  public accessorialLinesSummary: any = {};
  public freeLinesPrice: any = {};
  public additionLinesSummary: any = {};
  public additionalLinesPrice: any = {};
  public freeLinesSummary: any = {};
  public lineBasePriceBeforeDiscount: any = {};
  public priceOfferCopy: any;
  public additionOptionsMap: any = {};
  public finalAdditionOptionsMap: any = {};
  public showAdditionButton: any = {};
  public totalSpotsQuantityPrice: any = {};
  public orderTotalPrice: number;
  public volumeUnit: string;
  public linesPriceDetails: any = {};
  public PriceType: typeof PriceType = PriceType;
  public linesTotals: any = {};

  constructor(private splitService: SplitService, private PricePlanService) {
    this.currencySymbol = this.splitService.getCurrencySymbol();
    this.volumeUnit = this.splitService.getSiteDistanceSmallUnit();
  }

  $onInit() {
    this.priceOfferCopy = angular.copy(this.priceOffer);
    this._getSiteAdditions();
    this._setLinesData(this.priceOfferCopy.pricingDataInfos);
    this.calculateOrderTotalPrice();
  }


  $onChanges(changes: angular.IOnChangesObject) {
    if ((changes.isEditMode && !changes.isEditMode.isFirstChange()) || (changes.priceOffer && !changes.priceOffer.isFirstChange())) {
      this.priceOfferCopy = angular.copy(this.priceOffer);
      this._setLinesData(this.priceOfferCopy.pricingDataInfos);
      this.calculateOrderTotalPrice();
    }
  }

  onLinePriceChange(line, initialPriceDetailLine) {
    const initialPriceDetailLineIndex = _.findIndex(line.priceDetails.initialPriceDetailLines, (item: any) => {
      return item.id === initialPriceDetailLine.id;
    });
    this._recalculateLineAccessorialsBasePrice(line);
    line.priceDetails.initialPriceDetailLines[initialPriceDetailLineIndex].price = initialPriceDetailLine.price;
    this.onPriceOfferChange({updatedPriceOffer: this.priceOfferCopy})
  }

  onQuantityPricingOptionChange(line, initialPriceDetailLine) {
    const initialPriceDetailLineIndex = _.findIndex(line.priceDetails.initialPriceDetailLines, (item: any) => {
      return item.id === initialPriceDetailLine.id;
    })
    line.priceDetails.initialPriceDetailLines[initialPriceDetailLineIndex].lineType = initialPriceDetailLine.lineType;
    this._recalculateLineAccessorialsBasePrice(line);
    this.onPriceOfferChange({updatedPriceOffer: this.priceOfferCopy});
  }

  linePriceDetailsWithDiscount(linePriceDetails) {
    if (linePriceDetails.lineType === 'Default') {
      return (linePriceDetails.count * linePriceDetails.price) + ((linePriceDetails.adjustment || 0) * linePriceDetails.count);
    } else if (linePriceDetails.lineType === 'Percentage') {
      return (linePriceDetails.count * linePriceDetails.price) + ((((linePriceDetails.adjustment || 0) * linePriceDetails.price) / 100) * linePriceDetails.count);
    } else {
      return linePriceDetails.adjustment;
    }
  }

  onAdjustmentChange(line, initialPriceDetailLine) {
    const initialPriceDetailLineIndex = _.findIndex(line.priceDetails.initialPriceDetailLines, (item: any) => {
      return item.id === initialPriceDetailLine.id;
    })
    line.priceDetails.initialPriceDetailLines[initialPriceDetailLineIndex].adjustment = initialPriceDetailLine.adjustment;
    this._recalculateLineAccessorialsBasePrice(line);
    this.onPriceOfferChange({updatedPriceOffer: this.priceOfferCopy});
  }

  //Additions And Accessorials
  selectedAdditionOptions(line) {
    this.additionOptionsMap[line.fulfillmentLineId] = _.mapValues(_.keyBy(this.additionOptions, 'id'), (addition) => {
      const usedAdditionIds = _.map(_.get(line, 'priceDetails.initialAdditionLines'), 'id');
      return _.includes(usedAdditionIds, addition.id)
    })
  }

  addAdditionLine(line) {
    const newAdditionLine = {
      id: undefined,
      name: undefined,
      description: "",
      count: 1,
      price: 0,
      lineType: "Default"
    }

    if (!_.get(line, 'priceDetails.initialAdditionLines')) {
      line.priceDetails.initialAdditionLines = [];
    }

    line.priceDetails.initialAdditionLines = _.concat(line.priceDetails.initialAdditionLines, newAdditionLine);
    this.onPriceOfferChange({updatedPriceOffer: this.priceOfferCopy});
  }

  addFreeLine(line) {
    const newFreeLine = {
      id: undefined,
      name: undefined,
      description: "",
      count: 1,
      price: 0,
      lineType: "Default"
    }

    if (!_.get(line, 'priceDetails.freeLines')) {
      line.priceDetails.freeLines = [];
    }

    line.priceDetails.freeLines = _.concat(line.priceDetails.freeLines, newFreeLine);
    this.onPriceOfferChange({updatedPriceOffer: this.priceOfferCopy});
  }

  changeTotalPriceDiscountType(isFixedPriceDiscount) {
    this.priceOfferCopy.isFixedPriceDiscount = isFixedPriceDiscount;
    this.calculateOrderTotalPrice();
    this.onPriceOfferChange({updatedPriceOffer: this.priceOfferCopy});
  }

  onChangeAdditionOption(line, additionLineId) {
    const selectedAddition = _.find(this.additionOptions, (addition) => {
      return addition.id === additionLineId;
    })
    if (selectedAddition) {
      const additionalLineIndex = _.findIndex(this.additionalLines[line.fulfillmentLineId], (additionalLine: any) => {
        return additionalLine.id === selectedAddition.id
      })
      this.additionalLines[line.fulfillmentLineId][additionalLineIndex].name = selectedAddition.name;
      this.additionalLines[line.fulfillmentLineId][additionalLineIndex].price = selectedAddition.price;
    }

    this.onPriceOfferChange({updatedPriceOffer: this.priceOfferCopy});
  }

  onChangeFinalAdditionOption(line) {
    const selectedFinalAddition = _.find(this.additionOptions, (addition) => {
      return addition.id === this.finalAdditionLines[line.fulfillmentLineId].id;
    })

    if (selectedFinalAddition) {
      this.finalAdditionLines[line.fulfillmentLineId].name = selectedFinalAddition;
    }

    this.onPriceOfferChange({updatedPriceOffer: this.priceOfferCopy});
  }

  removeAdditionLine(line, index) {
    line.priceDetails.initialAdditionLines.splice(index, 1);
    this.calculateInitialPriceOfferDetails(line);
    this.calculateOrderTotalPrice();
    this.onPriceOfferChange({updatedPriceOffer: this.priceOfferCopy});
  }

  removeFreeLine(line, index) {
    line.priceDetails.freeLines.splice(index, 1);
    this.calculateInitialPriceOfferDetails(line);
    this.calculateOrderTotalPrice();
    this.onPriceOfferChange({updatedPriceOffer: this.priceOfferCopy});
  }

  removeFinalAdditionLine(line, index) {
    line.priceDetails.finalAdditionLines.splice(index, 1);
    this.calculateInitialPriceOfferDetails(line);
    this.calculateOrderTotalPrice();
    this.onPriceOfferChange({updatedPriceOffer: this.priceOfferCopy});
  }

  // Lines Price Calculations
  calculateOrderTotalPrice() {
    this.orderTotalPrice = 0;
    _.forOwn(this.lineBaseTotalPrice, (item) => {
      this.orderTotalPrice = this.orderTotalPrice + item;
    });
    if (!!this.priceOfferCopy.isFixedPriceDiscount) {
      this.orderTotalPrice = this.orderTotalPrice - this.priceOfferCopy.discount;
    } else {
      this.orderTotalPrice = this.orderTotalPrice * ((100 - this.priceOfferCopy.discount) / 100);
    }
  }

  onDiscountAmountChange() {
    this.onPriceOfferChange({updatedPriceOffer: this.priceOfferCopy});
  }

  calculateInitialPriceOfferDetails(line) {
    this.selectedAdditionOptions(line);

    // Line base Calculations
    this.totalSpotsQuantityPrice[line.fulfillmentLineId] = {};
    _.forEach(line.priceDetails.initialPriceDetailLines, item => {
      this.totalSpotsQuantityPrice[line.fulfillmentLineId][item.name] = {}
      if (item.lineType === 'TotalFixedPrice') {
        this.totalSpotsQuantityPrice[line.fulfillmentLineId][item.name]['quantityPrice'] = item.adjustment;
      } else {
        this.totalSpotsQuantityPrice[line.fulfillmentLineId][item.name]['itemsPrice'] = item.price * item.count;
        if (item.lineType === 'Default') {
          this.totalSpotsQuantityPrice[line.fulfillmentLineId][item.name]['quantityPrice'] = item.adjustment * item.count;
        } else {
          this.totalSpotsQuantityPrice[line.fulfillmentLineId][item.name]['quantityPrice'] = ((item.adjustment * item.price) / 100) * item.count;
        }
      }
    })

    this.lineBasePriceBeforeDiscount[line.fulfillmentLineId] = ((line.priceDetails.initialPriceDetailLines[0].price || 0) * line.priceDetails.initialPriceDetailLines[0].count);

    const initialAdditions = _.get(line, 'priceDetails.initialAdditionLines', []);
    // const finalAdditions = _.get(line, 'priceDetails.finalAdditionLines', []);
    this.showAdditionButton[line.fulfillmentLineId] = initialAdditions?.length !== this.additionOptions?.length;

    // Accessorials and Addition Lines
    this.accessorialLines[line.fulfillmentLineId] = _.get(line, 'priceDetails.initialAccessorialLines', []);
    this.additionalLines[line.fulfillmentLineId] = _.get(line, 'priceDetails.initialAdditionLines', []);
    this.freeLines[line.fulfillmentLineId] = _.get(line, 'priceDetails.freeLines', []);
    this.finalAdditionLines[line.fulfillmentLineId] = _.get(line, 'priceDetails.finalAdditionLines', []);

    // Prices for Accessorial, Additional and Freeline
    this.accessorialLinesPrice[line.fulfillmentLineId] = _.reduce(this.accessorialLines[line.fulfillmentLineId], (sum, accessorialLine) => {
      return accessorialLine.lineType === "Percentage" ? sum + ((accessorialLine.price * accessorialLine.basePrice) / 100) * accessorialLine.count : sum + (accessorialLine.price * accessorialLine.count);
    }, 0);

    this.additionalLinesPrice[line.fulfillmentLineId] = _.reduce(this.additionalLines[line.fulfillmentLineId], (sum, additionLine) => {
      return additionLine.lineType === "Percentage" ? ((additionLine.price * additionLine.basePrice) / 100) * additionLine.count : sum + (additionLine.price * additionLine.count);
    }, 0);

    this.freeLinesPrice[line.fulfillmentLineId] = _.reduce(this.freeLines[line.fulfillmentLineId], (sum, freeLine) => {
      return freeLine.lineType === "Percentage" ? ((freeLine.price * freeLine.basePrice) / 100) * freeLine.count : sum + (freeLine.price * freeLine.count);
    }, 0);

    this.finalAdditionLinesPrice[line.fulfillmentLineId] = _.reduce(this.finalAdditionLines[line.fulfillmentLineId], (sum, finalAdditionLine) => {
      return finalAdditionLine.lineType === "Percentage" ? ((finalAdditionLine.price * finalAdditionLine.basePrice) / 100) * finalAdditionLine.count : sum + (finalAdditionLine.price * finalAdditionLine.count);
    }, 0);

    this.accessorialLinesSummary[line.fulfillmentLineId] = _.map(this.accessorialLines[line.fulfillmentLineId], (accessorialLine) => {
      const accessorialLineSummary = {
        name: undefined,
        type: undefined,
        basePrice: undefined,
        pricePerQuantity: undefined,
        quantity: undefined,
        finalPrice: undefined
      };
      if (accessorialLine.lineType === 'Percentage') {
        accessorialLineSummary.name = accessorialLine.name;
        accessorialLineSummary.type = 'Percentage';
        accessorialLineSummary.pricePerQuantity = accessorialLine.price;
        accessorialLineSummary.basePrice = accessorialLine.basePrice;
        accessorialLineSummary.finalPrice = ((accessorialLine.price * accessorialLine.basePrice) / 100);
      } else {
        accessorialLineSummary.name = accessorialLine.name;
        accessorialLineSummary.type = 'Default';
        accessorialLineSummary.pricePerQuantity = accessorialLine.price;
        accessorialLineSummary.quantity = accessorialLine.count;
        accessorialLineSummary.finalPrice = (accessorialLine.price * accessorialLine.count);
      }

      return accessorialLineSummary;
    })

    this.additionLinesSummary[line.fulfillmentLineId] = _.map(this.additionalLines[line.fulfillmentLineId], (additionalLine) => {
      const additionalLineSummary = {
        name: undefined,
        type: undefined,
        basePrice: undefined,
        pricePerQuantity: undefined,
        quantity: undefined,
        finalPrice: undefined
      };
      if (additionalLine.lineType === 'Percentage') {
        additionalLineSummary.name = additionalLine.name;
        additionalLineSummary.type = 'Percentage';
        additionalLineSummary.pricePerQuantity = additionalLine.price;
        additionalLineSummary.basePrice = additionalLine.basePrice;
        additionalLineSummary.finalPrice = ((additionalLine.price * additionalLine.basePrice) / 100);
      } else {
        additionalLineSummary.name = additionalLine.name;
        additionalLineSummary.type = 'Default';
        additionalLineSummary.pricePerQuantity = additionalLine.price;
        additionalLineSummary.finalPrice = (additionalLine.price * additionalLine.count);
      }
      additionalLineSummary.quantity = additionalLine.count;
      return additionalLineSummary;
    })
    this.freeLinesSummary[line.fulfillmentLineId] = _.map(this.freeLines[line.fulfillmentLineId], (freeLine) => {
      const freeLineSummary = {
        name: undefined,
        type: undefined,
        basePrice: undefined,
        pricePerQuantity: undefined,
        quantity: undefined,
        finalPrice: undefined
      };
      if (freeLine.lineType === 'Percentage') {
        freeLineSummary.name = freeLine.name;
        freeLineSummary.type = 'Percentage';
        freeLineSummary.pricePerQuantity = freeLine.price;
        freeLineSummary.basePrice = freeLine.basePrice;
        freeLineSummary.finalPrice = ((freeLine.price * freeLine.basePrice) / 100);
      } else {
        freeLineSummary.name = freeLine.name;
        freeLineSummary.type = 'Default';
        freeLineSummary.pricePerQuantity = freeLine.price;
        freeLineSummary.quantity = freeLine.count;
        freeLineSummary.finalPrice = (freeLine.price * freeLine.count);
      }

      return freeLineSummary;
    });

    this.finalAdditionLinesSummary[line.fulfillmentLineId] = _.map(this.finalAdditionLines[line.fulfillmentLineId], (finalAdditionLine) => {
      const finalAdditionLineSummary = {
        name: undefined,
        type: undefined,
        basePrice: undefined,
        pricePerQuantity: undefined,
        quantity: undefined,
        finalPrice: undefined
      };
      if (finalAdditionLine.lineType === 'Percentage') {
        finalAdditionLineSummary.name = finalAdditionLine.name;
        finalAdditionLineSummary.type = 'Percentage';
        finalAdditionLineSummary.pricePerQuantity = finalAdditionLine.price;
        finalAdditionLineSummary.basePrice = finalAdditionLine.basePrice;
        finalAdditionLineSummary.finalPrice = ((finalAdditionLine.price * finalAdditionLine.basePrice) / 100);
      } else {
        finalAdditionLineSummary.name = finalAdditionLine.name;
        finalAdditionLineSummary.type = 'Default';
        finalAdditionLineSummary.pricePerQuantity = finalAdditionLine.price;
        finalAdditionLineSummary.quantity = finalAdditionLine.count;
        finalAdditionLineSummary.finalPrice = (finalAdditionLine.price * finalAdditionLine.count);
      }

      return finalAdditionLineSummary;
    })

    this._setLineBasePrice(line);
  }

  private _recalculateLineAccessorialsBasePrice(line) {
    _.forEach(line.priceDetails.initialAccessorialLines, accessorial => {
      if (accessorial.lineType === 'Percentage') {
        accessorial.basePrice = _.reduce(line.priceDetails.initialPriceDetailLines, function (sum, priceDetailLine) {
          if (priceDetailLine.lineType === 'TotalFixedPrice') {
            return sum + (priceDetailLine.adjustment || 0);
          } else {
            return sum + (((priceDetailLine.price || 0) * priceDetailLine.count) + (priceDetailLine.count * (priceDetailLine.adjustment || 0)));
          }
        }, 0);
      }
    });
  }

  private _getSiteAdditions() {
    this.PricePlanService.getSiteAdditions()
      .then((additions: Addition[]) => {
        this.additionOptions = additions;
      })
  }

  private _setLineBasePrice(line) {
    const extrasSumPrice: number = this.accessorialLinesPrice[line.fulfillmentLineId] + this.additionalLinesPrice[line.fulfillmentLineId] + this.freeLinesPrice[line.fulfillmentLineId] + this.finalAdditionLinesPrice[line.fulfillmentLineId];
    let linePrice: number = 0;
    _.forEach(_.get(line, 'priceDetails.initialPriceDetailLines', []), (item) => {
      const adjustment = item.adjustment || 0;
      if (item.lineType === 'TotalFixedPrice') {
        linePrice += adjustment;
      } else if (item.lineType === 'Percentage') {
        linePrice += (item.price * item.count) + ((item.price * adjustment * item.count) / 100);
      } else {
        linePrice += (item.price * item.count) + (adjustment * item.count);
      }
    })
    this.lineBaseTotalPrice[line.fulfillmentLineId] = extrasSumPrice + linePrice;
  }

  private _setLinesData(lines) {
    _.forEach(lines, (line, index) => {
      if (!_.get(line, 'priceDetails.initialPriceDetailLines')) {
        this._initiateLinePriceDetails(line);
      }
      if (!_.get(line, 'priceDetails.priceType')) {
        line.priceDetails.priceType = 'BySpot'
      }
      this._initLinesPackages(this.priceOfferCopy);
      this.calculateInitialPriceOfferDetails(line);
    })
  }

  private _initiateLinePriceDetails(line) {
    const count = this._packagesRequiredSpotsCount(line.itemLines);
    const initialPriceDetailLine = {
      name: "",
      description: "",
      count: count,
      price: 0,
      adjustment: 0,
      lineType: "Default"
    }
    line.priceDetails.initialPriceDetailLines = [];
    line.priceDetails.initialPriceDetailLines = _.concat(line.priceDetails.initialPriceDetailLines, initialPriceDetailLine);
  }

  private _initLinesPackages(priceOffer) {
    _.forEach(priceOffer.pricingDataInfos, (line, index) => {
      this.linesPriceDetails[line.fulfillmentLineId] = [];
      this.linesTotals[line.fulfillmentLineId] = {};
      const lineItems = getFulfillmentLineItems(line, priceOffer.itemLines);

      this.linesTotals[line.fulfillmentLineId].weight = priceOffer.itemLines.reduce((sum, i) => {
        if (lineItems.includes(i)) {
          return sum + (i.weight * i.count);
        }
      }, 0);
      this.linesTotals[line.fulfillmentLineId].volume = priceOffer.itemLines.reduce((sum, i) => {
        if (lineItems.includes(i)) {
          if (i.dimensions?.cube) {
            return sum + i.dimensions.cube;
          } else {
            return sum + i.volume;
          }
        }
      }, 0);

      _.forEach(line.priceDetails.initialPriceDetailLines, (initialPriceDetailLine, index) => {
        const initialPriceDetailLineCopy = angular.copy(initialPriceDetailLine);
        if (line.priceDetails.priceType === this.PriceType.ByPackageSize) {
          initialPriceDetailLineCopy.itemLines = _.filter(priceOffer.itemLines, item => {
            return item.id === initialPriceDetailLineCopy.id
          });
        } else if (line.priceDetails.priceType === this.PriceType.ByTotalPackagesValues) {
          initialPriceDetailLineCopy.itemLines = priceOffer.itemLines.filter(i => lineItems.includes(i));
        } else {
          initialPriceDetailLineCopy.itemLines = priceOffer.itemLines;
        }

        if (line.priceDetails.priceType !== this.PriceType.ByTotalPackagesValues) {
          initialPriceDetailLineCopy.itemLines.forEach(item => {
            item.count = line.priceDetails.initialPriceDetailLines.find(i => i.id === item.id)?.count || 0;
          })
        }

        this.linesPriceDetails[line.fulfillmentLineId].push(initialPriceDetailLineCopy);
      })
    })
  }

  private _packagesRequiredSpotsCount(packagesList) {
    return _.reduce(packagesList, (sum, item) => {
      return sum + (item.count * item.requiredSpots);
    }, 0);
  }

}

angular
  .module('bringoz.admin.oms')
  .component('omsOrderPriceOverviewLineView', {
    require: {
      form: '^form'
    },
    bindings: {
      order: '<?',
      priceOffer: '<',
      isEditMode: '<',
      showFreeLineAddition: '<?',
      onPriceOfferChange: '&',
      onOrderChange: '&?'
    },
    template: require('./oms-order-price-overview-line-view.html').default,
    controller: OmsOrderPriceOverViewLineViewCtrl
  });
